export const social = [
    {value: 'Facebook', label: 'Facebook'},
    {value: 'WhatsApp', label: 'WhatsApp'},
    {value: 'Instagram', label: 'Instagram'},
    {value: 'Telegram', label: 'Telegram'},
];

//=== social
export const SOCIAL = {
    FACEBOOK: 'Facebook',
    WHATSAPP: 'WhatsApp',
    INSTAGRAM: 'Instagram',
    TELEGRAM: 'Telegram'
}

export const SOCIAL_ICONS = {
    [SOCIAL.FACEBOOK]: '/static/brands/facebook.svg',
    [SOCIAL.WHATSAPP]: '/static/brands/whatsapp.svg',
    [SOCIAL.INSTAGRAM]: '/static/brands/instagram.svg',
    [SOCIAL.TELEGRAM]: '/static/brands/telegram.svg',
}